export default __webpack_public_path__ + "static/media/5f87063df2fc7169fed6fe720363a685.02b67a48.svg";